export default {
    "ecstasy":"#F6881A",
    "summerGreen": "#90BF93",
    "supernova": "#FBC70B",
    "goblin": "#34733C",
    "white": "#FFFFFF",
    "heavyMetal": "#1D221D",
};